import { render, staticRenderFns } from "./kycPage.vue?vue&type=template&id=bd0321a0"
import script from "./kycPage.vue?vue&type=script&lang=js"
export * from "./kycPage.vue?vue&type=script&lang=js"
import style0 from "./kycPage.vue?vue&type=style&index=0&id=bd0321a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports